import { Card } from '../../legacy/hui/src/styled';

export default Card.extend`
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
`;
